import { useEffect, useState } from 'react';

export type TBreakpoint = 'mobile' | 'tablet' | 'desktop' | string;

interface IUseMediaQuery {
  (query: string): boolean;
}

const BREAKPOINTS = {
  mobile: '(max-width: 480px)',
  tablet: '(max-width: 768px)',
  desktop: '(min-width: 769px)',
};

const useMediaQuery: IUseMediaQuery = (query: string) => {
  const [matches, setMatches] = useState<boolean>(false);

  useEffect(() => {

    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
      return;
    }

    const mediaQueryList = window.matchMedia(query);

    setMatches(mediaQueryList.matches);
    const handleChange = (event: MediaQueryListEvent) => {
      setMatches(event.matches);
    };

    mediaQueryList.addEventListener('change', handleChange);

    return () => {
      mediaQueryList.removeEventListener('change', handleChange);
    };
  }, [query]);

  return matches;
};

export const useMobileMediaQuery = () => useMediaQuery(BREAKPOINTS.mobile);
export const useTabletMediaQuery = () => useMediaQuery(BREAKPOINTS.tablet);
export const useDesktopMediaQuery = () => useMediaQuery(BREAKPOINTS.desktop);

export default useMediaQuery;
